import { render, staticRenderFns } from "./RegisterRecheck.vue?vue&type=template&id=384d3857&"
import script from "./RegisterRecheck.vue?vue&type=script&lang=js&"
export * from "./RegisterRecheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports